import {Component, Injector, Input, OnInit} from '@angular/core';
import {NgbActiveModal, NgbCollapseModule, NgbTooltipModule} from '@ng-bootstrap/ng-bootstrap';
import {forkJoin, Subject} from 'rxjs';
import {environment} from '../../../environments/environment';
import MapView from '@arcgis/core/views/MapView';
import ZoomViewModel from '@arcgis/core/widgets/Zoom/ZoomViewModel';
import {HttpClient} from '@angular/common/http';
import {StandbyGeneratorsService} from '../../standby-generators/standby-generators.service';
import {filter, switchMap, tap} from 'rxjs/operators';
import FeatureLayer from '@arcgis/core/layers/FeatureLayer';
import GraphicsLayer from '@arcgis/core/layers/GraphicsLayer';
import MapImageLayer from '@arcgis/core/layers/MapImageLayer';
import Fullscreen from '@arcgis/core/widgets/Fullscreen';
import Graphic from '@arcgis/core/Graphic';
import Point from '@arcgis/core/geometry/Point';
import LabelClass from '@arcgis/core/layers/support/LabelClass';
import LayerList from '@arcgis/core/widgets/LayerList';
import SimpleRenderer from '@arcgis/core/renderers/SimpleRenderer';
import WebMap from '@arcgis/core/WebMap';
type TextSymbolProperties = TextSymbolTextSymbolProperties;
import {ContactsService} from '../../contacts/contacts.service';
import {OneStopService} from '../../one-stop/one-stop.service';
import {UstService} from '../../ust/ust.service';
import {ReviewService} from '../review.service';
import {SitesService} from '@shared/services/sites.service';
import BasemapGallery from '@arcgis/core/widgets/BasemapGallery';
import Expand from '@arcgis/core/widgets/Expand';
import SimpleFillSymbol from '@arcgis/core/symbols/SimpleFillSymbol';
import PortalBasemapsSource from '@arcgis/core/widgets/BasemapGallery/support/PortalBasemapsSource';
import Portal from '@arcgis/core/portal/Portal';
import TextSymbol from '@arcgis/core/symbols/TextSymbol';
import type { TextSymbolProperties as TextSymbolTextSymbolProperties } from "@arcgis/core/symbols/TextSymbol";
import {AsyncPipe, NgForOf, NgIf} from '@angular/common';
import {RoutingReviewComponent} from '../routing-review/routing-review.component';
import {ReviewButtonsComponent} from '../review-buttons/review-buttons.component';
import {PesticidesService} from '../../services/pesticides.service';
import {IsImagePipe} from '@shared/pipes/is-image.pipe';
import {ToTrustedPipe} from '@shared/pipes/to-trusted.pipe';
import {DisplayFieldComponent} from '@shared/display-field/display-field.component';
import {AttachmentsComponent} from '@shared/attachments/attachments.component';
import {DisplayPipe} from '@shared/pipes/display.pipe';
import {SummaryPanelComponent} from '@shared/summary-panel/summary-panel.component';

@Component({
  selector: 'app-summary-modal',
  templateUrl: './summary-modal.component.html',
  styleUrls: ['./summary-modal.component.css'],
  imports: [
    AsyncPipe,
    NgIf,
    IsImagePipe,
    ToTrustedPipe,
    DisplayFieldComponent,
    AttachmentsComponent,
    NgForOf,
    NgbTooltipModule,
    NgbCollapseModule,
    DisplayPipe,
    SummaryPanelComponent,
    ReviewButtonsComponent,
    RoutingReviewComponent
  ]
})
export class SummaryModalComponent implements OnInit {
  @Input() item: any;
  @Input() meta: any;
  @Input() reviewType!: string;

  public permit: any;
  public contacts: any[];
  public permitMeta: Subject<any> = new Subject<any>();
  public contactsMeta: Subject<any> = new Subject<any>();
  public generators: any[];
  public generatorsMeta: Subject<any> = new Subject<any>();
  public permitDisplayFields: any;
  public typeChoices: any[];
  public isCollapsed = true;
  public standbyService: StandbyGeneratorsService;

  constructor(public modalInstance: NgbActiveModal, private http: HttpClient, public contactsService: ContactsService,
              public sitesService: SitesService, private injector: Injector,
              public oneStopService: OneStopService, public ustService: UstService, public reviewService: ReviewService,
              public pesticidesService: PesticidesService) {
    this.standbyService = this.injector.get<StandbyGeneratorsService>(StandbyGeneratorsService);

  }

  public site: any;
  public siteMeta: Subject<any> = new Subject<any>();
  public reviewMeta: any;
  public showMap = false;
  public mapLocked = true;
  private navigationListener = [];
  private navigationDisabled = true;
  // public serviceMeta: Subject<any> = new Subject<any>();
  public serviceMeta: any;

  // private basemap = new Basemap({
  //   title: 'WALTERS Basemap',
  //   baseLayers: [
  //     new TileLayer({
  //       url: environment.baseMapService,
  //       listMode: 'hide'
  //     })
  //   ],
  //   referenceLayers: [
  //     new VectorTileLayer({
  //       url: 'https://www.arcgis.com/sharing/rest/content/items/af6063d6906c4eb589dfe03819610660/resources/styles/root.json',
  //       listMode: 'hide'
  //     })
  //   ]
  // });
  private siteLayer = new FeatureLayer({url: environment.sitesService});
  private graphicsLayer = new GraphicsLayer({
    listMode: 'hide'
  });

  // private nhdLayer = new MapImageLayer({
  //   url: 'https://hydro.nationalmap.gov/arcgis/rest/services/nhd/MapServer',
  //   visible: true,
  //   title: 'National Hydrography Dataset'
  // });

  private waltersSites = new MapImageLayer({
    url: 'https://gis.epa.guam.gov/arcgis/rest/services/All_Sites/MapServer',
    visible: false,
    title: 'WALTERS Sites'
  });
  // private gwa = new MapImageLayer({
  //   url: environment.gwaService,
  //   visible: true
  // });

  // private wetlands = new MapImageLayer({
  //   url: 'https://www.fws.gov/wetlandsmapservice/rest/services/Wetlands/MapServer',
  //   visible: true
  // })

  // private fema = new MapImageLayer({
  //   url: 'https://hazards.fema.gov/gis/nfhl/rest/services/public/NFHL/MapServer',
  //   visible: true,
  //   // sublayers: [
  //   //   {id: 31, visible: false},
  //   //   {id: 30, visible: false},
  //   //   {id: 26, visible: false},
  //   //   {id: 13, visible: false},
  //   //   {id: 12, visible: false},
  //   //   {id: 11, visible: false},
  //   //   {id: 10, visible: false},
  //   //   {id: 9, visible: false},
  //   //   {id: 8, visible: false},
  //   //   {id: 6, visible: false},
  //   //   {id: 4, visible: false},
  //   //   {id: 25, visible: false},
  //   //   {id: 28, visible: false},
  //   //   {id: 27, visible: false},
  //   //   {id: 19, visible: false},
  //   //   {id: 5, visible: false},
  //   //   {id: 32, visible: false},
  //   //   {id: 7, visible: false},
  //   //   {id: 24, visible: false},
  //   //   {id: 18, visible: false},
  //   //   {id: 15, visible: false},
  //   //   {id: 29, visible: false},
  //   //   {id: 23, visible: false},
  //   //   {id: 16, visible: false},
  //   //   {id: 14, visible: false},
  //   //   {id: 20, visible: false},
  //   //   {id: 17, visible: false},
  //   //   {id: 22, visible: false},
  //   //   {id: 34, visible: false},
  //   //   {id: 1, visible: false},
  //   //   {id: 3, visible: false},
  //   //   {id: 0, visible: false}
  //   // ]
  // })

  // private gpz = new MapImageLayer({url: 'https://gis.epa.guam.gov/arcgis/rest/services/Public/GroundwaterProtectionZone/MapServer'})

  private parcelLabelSymbol = {
    color: 'white',
    backgroundColor: null,
    borderLineColor: null,
    borderLineSize: null,
    verticalAlignment: 'bottom',
    horizontalAlignment: 'center',
    // rightToLeft: false,
    angle: 0,
    xoffset: 0,
    yoffset: 0,
    kerning: true,
    haloColor: 'black',
    haloSize: 1,
    font: {
      family: 'Arial',
      size: 12,
      style: 'normal',
      weight: 'normal',
      decoration: 'none'
    }
  } as TextSymbolProperties;

  // private references = new VectorTileLayer({
  //   url: 'https://www.arcgis.com/sharing/rest/content/items/af6063d6906c4eb589dfe03819610660/resources/styles/root.json',
  //   listMode: 'hide'
  // });

  private parcelLabel = new LabelClass({
    labelPlacement: 'always-horizontal',
    where: null,
    labelExpressionInfo: {expression: '$feature.Parcel_Sea'},
    useCodedValues: true,
    symbol: new TextSymbol(this.parcelLabelSymbol),
    minScale: 5000,
    maxScale: 0
  });

  private parcelSymbol = new SimpleFillSymbol({
    color: [0, 0, 0, 0],
    style: 'solid',
    outline: {
      color: [133, 133, 133, 255],
      width: 1
    }
  });

  private parcelRenderer = new SimpleRenderer({
    symbol: this.parcelSymbol
  });

  // private parcelLayer = new FeatureLayer({
  //   url: environment.parcelLayerService,
  //   visible: true,
  //   minScale: 8000,
  //   outFields: ['*'],
  //   labelingInfo: [this.parcelLabel],
  //   title: 'Parcels',
  //   renderer: this.parcelRenderer
  // });
  private map: WebMap;
  private view: MapView;
  private zoom: ZoomViewModel;

  public organizationDisplayFields = ['contact_display_name', 'contact_phone_number', 'contact_fax_number',
    'contact_address_line_1', 'contact_address_line_2', 'contact_city', 'contact_state',
    'contact_zip_code', 'contact_country'];
  public contactsDisplayFields = [
    'contact_display_name', 'contact_title', 'contact_division_name', 'contact_phone_number',
    'contact_alternate_phone', 'contact_email_address', 'contact_address_line_1', 'contact_address_line_2',
    'contact_city', 'contact_state', 'contact_zip_code', 'contact_country'
  ];

  ngOnInit(): void {
    this.http.get<any>(`${environment.baseUrl}/review/permit_type/`).subscribe(response => {
      this.typeChoices = response;
    });
    this.sitesService.get<any>(this.item.site_id).subscribe(siteResponse => {

      this.site = siteResponse.result;
      this.siteMeta.next(siteResponse.meta);

      this.map = new WebMap({portalItem: {id: environment.webmapID}});
      this.map.when(() => {
        this.map.addMany([
          // this.parcelLayer,
          // this.gwa,
          this.waltersSites,
          this.graphicsLayer
        ]);
      })

      // this.map = new Map({
      //   basemap: this.basemap,
      //   layers: [
      //     this.references,
      //     this.gpz,
      //     this.nhdLayer,
      //     this.wetlands,
      //     this.fema,
      //     this.parcelInfo,
      //     this.gwa,
      //     this.waltersSites,
      //     this.graphicsLayer
      //   ]
      // });


      this.siteLayer.load();
      this.siteLayer.when(() => {
        const symbol = (this.siteLayer.renderer as SimpleRenderer).symbol;
        siteResponse.meta.symbol = symbol;
        this.siteMeta.next(siteResponse.meta);

        this.view = new MapView({
          map: this.map,
          container: 'mapDiv',
          ui: {components: []},
          // spatialReference: {wkid: 3857}
        });
        this.zoom = new ZoomViewModel({view: this.view});
        const fullscreen = new Fullscreen({view: this.view});
        this.view.ui.add(fullscreen, 'bottom-right');

        const basemapGallery = new BasemapGallery({
          view: this.view,
          source: new PortalBasemapsSource({portal: new Portal()})
        });
        const basemapExpand = new Expand({
          view: this.view,
          content: basemapGallery,
          expandIcon: 'basemap',
          autoCollapse: true,
          group: 'top-left',
          expandTooltip: 'Basemaps'
        })
        this.view.ui.add(basemapExpand, 'top-left');
        // tslint:disable-next-line:no-unused-expression
        new LayerList({
          view: this.view,
          container: 'layerList',
          listItemCreatedFunction: event => {
            const item = event.item;
            if (item.layer.type !== 'group') {
              // don't show legend twice
              item.panel = {
                content: 'legend',
                open: false
              };
              item.open = false;
            }
          }
        });
        this.view.when(() => {
          if (this.site.shape.x !== undefined || this.site.shape.y !== undefined) {
            const sitePoint = new Graphic();
            sitePoint.geometry = new Point({
              x: this.site.shape.x,
              y: this.site.shape.y,
              spatialReference: {wkid: 3857}
            });
            sitePoint.symbol = symbol;
            this.graphicsLayer.add(sitePoint);
            this.view.goTo({
              target: sitePoint,
              zoom: 17
            });
          }
          // this.disableMapNavigation();
          this.showMap = true;

        });

      });

      if (this.item.content_type === 193) { // standby generator reports
        this.standbyService.annualReportsService.loadMetadata().subscribe(
          meta => {
            const annual_report_meta = {
              ...this.standbyService.loadAnnualReportsMeta(meta),
              searchObject: {search: this.item.globalid, verified: false}
            };
            this.permitMeta.next(annual_report_meta);
          }
        )
      } else if (this.item.content_type === 111) { // standby generator permits


        forkJoin({
          permits: this.standbyService.permitsService.loadMetadata(),
          generators: this.standbyService.generatorsService.loadMetadata()
        }).subscribe(
          meta => {
            const permits_meta = {
              ...this.standbyService.loadPermitMeta(meta.permits),
              generators: this.standbyService.loadGeneratorsMeta(meta.generators),
              searchObject: this.reviewType === 'acceptance' ? {
                search: this.item.globalid,
                verified: false
              } : {search: this.item.record_id}
            };
            permits_meta.relatedItems = ['generators']
            if (this.reviewType === 'acceptance') {
              permits_meta.generators.searchObject = {verified: false}
            }

            this.permitMeta.next(permits_meta);
          }
        )
        // const promises = [];
        // promises.push(Restangular.all('organizations').getList({search: this.item.site_id}).then(function (response) {
        //   this.organization = response[0];
        //   this.organization.meta = response.meta;
        // }));


        // promises.push(Restangular.all('contacts').getList({search: this.item.site_id}).then(response => {
        //   this.contacts = response;
        //   this.contacts_meta = response.meta;
        // }));

        // Restangular.one('sites', this.item.site_id).get().then(response => {
        //   this.site = response;
        // });

        // var promises = [];
        // promises.push(Restangular.all('organizations').getList({search: this.item.site_id}).then(function (response) {
        //   this.organization = response[0];
        //   this.organization.meta = response.meta;
        // }));

        // promises.push();


        // this.standbyService.loadData({search: this.item.site_id}).pipe(
        //   tap(() => {
        //     this.permitDisplayFields = this.standbyService.meta.fields.permits.display_fields;
        //   }),
        //   switchMap(() => this.standbyService.permitsService.getList<any>({search: this.standbyService.item.globalid})),
        //   filter(r => r.results.length > 0),
        //   switchMap(permitResponse => {
        //     this.permit = permitResponse.results[0];
        //     permitResponse.meta.attachment_urls = ['standbygenerator/permits_attachments'];
        //     this.permitMeta.next(permitResponse.meta);
        //     this.serviceMeta = this.standbyService.permitsService.meta;
        //     return this.standbyService.permitContactsService.getList<any>({search: this.permit.globalid});
        //   }),
        //   tap(contactsResponse => {
        //     this.contacts = contactsResponse.results;
        //     this.contactsMeta.next(contactsResponse.meta);
        //   }),
        // this.permit.meta.attachment_url = 'standbygenerator/permits_attachments';
        //       this.permit.meta.fields.responsible_party.choices = this.contacts.map(function (item) {
        //   return {display_name: item.first_name + ' ' + item.last_name, value: item.globalid};
        // });
        // this.permit.meta.fields.permittee.choices = [{
        //   display_name: this.organization.name,
        //   value: this.organization.globalid
        //       }];
        // }
        // this.organization = response[0].permittee;
        // this.organization.meta = response.meta.fields.permittee.children;
        // });
        // });
        // switchMap(() => {
        //   return this.standbyService.generatorsService
        //     .getList<any>({search: this.standbyService.item.globalid})
        // }),
        // tap(generatorsResponse => {
        //   this.generators = generatorsResponse.results;
        //   generatorsResponse.meta.featureService = this.standbyService.meta.fields.generators.featureService;
        //
        //
        //   // this.modalInstance.rendered.then(() => {
        //
        //   const generatorLayer = new FeatureLayer(generatorsResponse.meta.featureService);
        //
        //   generatorLayer.load();
        //   generatorLayer.when(() => {
        //     const symbol = (generatorLayer.renderer as SimpleRenderer).symbol;
        //     generatorsResponse.meta.symbol = symbol;
        //     this.generatorsMeta.next(generatorsResponse.meta);
        //
        //     this.generators.forEach(generator => {
        //       if (generator.shape.x !== undefined || generator.shape.y !== undefined) {
        //         const genPoint = new Graphic();
        //         genPoint.geometry = new Point({
        //           x: generator.shape.x,
        //           y: generator.shape.y,
        //           spatialReference: {wkid: 3857}
        //         });
        //         genPoint.symbol = symbol;
        //         this.graphicsLayer.add(genPoint);
        //       }
        //     });
        //   });
        //
        // })).subscribe();


      } else if (this.item.content_type === 250) {
        this.oneStopService.permitsService.loadMetadata().subscribe(
          meta => {
            const permit_meta = {
              ...this.oneStopService.loadPermitMeta(meta),
              searchObject: {search: this.item.record_id}
            };
            permit_meta.subItems = ['comments', 'contacts', 'attachments', 'agencyattachments', 'supportingattachments']
            this.permitMeta.next(permit_meta);
          }
        );
        // this.oneStopService.loadData({search: this.item.site_id}).pipe(
        //   switchMap(() => {
        //     return this.oneStopService.permitsService.getList({search: this.oneStopService.item.globalid})
        //   }),
        //   filter(r => r.results.length > 0),
        //   tap(r => {
        //     this.permit = r.results[0];
        //     r.meta.attachment_urls = ['onestop/permits/attach', 'onestop/permits/agencyattach', 'onestop/permits/supportingattach'];
        //     this.permitMeta.next(r.meta);
        //     this.serviceMeta = this.oneStopService.meta.fields.onestoppermits;
        //     this.permitDisplayFields = this.oneStopService.meta.fields.onestoppermits.display_fields;
        //   })
        // ).subscribe();
      } else if (this.item.content_type === 167) {
        this.ustService.loadData({search: this.item.site_id}).pipe(
          switchMap(() => {
            return this.ustService.permitsService.getList({search: this.ustService.item.globalid})
          }),
          filter(r => r.results.length > 0),
          tap(r => {
            this.permit = r.results[0];
            r.meta.attachment_urls = ['ust/permitsattach'];
            this.permitMeta.next(r.meta);
            this.serviceMeta = this.ustService.meta.fields.permits;
            this.permitDisplayFields = this.ustService.meta.fields.permits.display_fields;
          })).subscribe();
      } else if (this.item.content_type === 220) {
        this.pesticidesService.loadMetadata().subscribe(meta => {
            const permit_meta = {
              ...this.pesticidesService.loadNOAMetadata(meta),
              searchObject: {search: this.item.globalid}
            };
            this.permitMeta.next(permit_meta);
          }
        )
      }
    });
  }

  private disableMapNavigation() {
    this.navigationDisabled = true;
    this.navigationListener.push(this.view.on('drag', event => {
      event.stopPropagation();
    }));
    this.navigationListener.push(this.view.on('key-down', event => {
      const prohibitedKeys = ['+', '-', 'Shift', '_', '='];
      const keyPressed = event.key;
      if (prohibitedKeys.indexOf(keyPressed) !== -1) {
        event.stopPropagation();
      }
    }));
    this.navigationListener.push(this.view.on('double-click', event => {
      event.stopPropagation();
    }));
    this.navigationListener.push(this.view.on('mouse-wheel', event => {
      event.stopPropagation();
    }));
  }

  private enableMapNavigation() {
    this.navigationDisabled = false;
    this.navigationListener.forEach(listener => {
      listener.remove();
    });
  }

  // map = new Map("waltersModalMapDiv", {
  //   center: [144.8, 13.45],
  //   zoom: 10,
  //   slider: false
  // });

  // var graphics = [];
  // angular.extend(graphics, mainMap.graphics.graphics);

  // map.on('load', function () {
  //     mapService.getMap().then(function (mainMap) {
  //         angular.forEach(mainMap.graphics.graphics, function (graphic) {
  //             if (graphic.attributes === undefined || graphic.attributes.globalid !== item.globalid) {
  //                 var _graphic = new Graphic(graphic.toJson());
  //                 map.graphics.add(_graphic);
  //             }
  //         });
  //     });
  // });


  // var generatorLayer = new FeatureLayer(this.generators.meta.featureService);
  // generatorLayer.load();
  // generatorLayer.when(function () {
  //   var symbol = generatorLayer.renderer.symbol;
  //   this.generators.meta.symbol = symbol;
  //   this.$apply();
  //
  //   angular.forEach(this.generators, function (generator) {
  //     if (generator.shape.x !== undefined || generator.shape.y !== undefined) {
  //       var genPoint = new Graphic();
  //       var geometry = new Point(generator.shape.x, generator.shape.y, new SpatialReference(3857));
  //       genPoint.geometry = geometry;
  //       genPoint.symbol = symbol;
  //       graphicsLayer.add(genPoint);
  //     }
  //   });
  // });

  public zoomIn() {
    this.zoom.zoomIn();
  }

  public zoomOut() {
    this.zoom.zoomOut();
  }


  public toggleMapLock() {
    if (!this.mapLocked) {
      this.mapLocked = true;
      this.disableMapNavigation();
    } else {
      this.mapLocked = false;
      this.enableMapNavigation();
    }
  }


  public close() {
    this.modalInstance.dismiss();
    this.map.destroy();
  }

  public accept(item, modalInstance) {
    console.log('must be overridden');
  }

  public get_generator_display_fields(item) {
    let displayFields = [
      'date_of_manufacture', 'unit_identification', 'description', 'useAP42', 'total_unburned_hydrocarbons',
      'toc_units', 'particulate_matter', 'pm_units', 'sulfur_dioxide', 'so2_units',
      'carbon_monoxide', 'co_units', 'nitrogen_oxide', 'no_units'];

    if (item.fuel_type === 'butane' || item.fuel_type === 'propane') {
      displayFields = displayFields.concat([
        //'nitrous_oxide', 'nitrous_oxide_units',
        'carbon_dioxide', 'carbon_dioxide_units', 'methane', 'methane_units'
      ]);
    }

    displayFields = displayFields.concat(['fuel_type', 'fuel_consumption',
      'tank_location', 'internal_tank_size', 'brake_horsepower',
      'brake_kilowatts', 'generator_make', 'generator_model', 'generator_serial_number',
      'engine_make', 'engine_model', 'engine_serial_number', 'engine_hours']);

    return displayFields;
  }


  // });

}
